import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_EMAIL_IDENTITY_API_URL,
    prepareHeaders: (headers) => {
        const user = localStorage.getItem('user');
        if (user) {
            try {
                const userToken = JSON.parse(user).token;
                headers.set('authorization', `Bearer ${userToken}`);
                headers.set('Content-Type', 'application/json');
            } catch (e) {
                console.error('Error parsing user token:', e);
            }
        }
        return headers;
    },
    credentials: "omit"
});

export const emailIdentityServiceApi = createApi({
    reducerPath: "emailIdentityServiceApi",
    baseQuery: baseQuery,
    tagTypes: ["CustomEmailDomain"],
    endpoints: (builder) => ({
        getIdentityStatus: builder.query({
            queryFn: async ({ tenancyId }, api, extraOptions, baseQuery) => {
                const result = await baseQuery(`api/identity/status?tenancyId=${tenancyId}`);

                // Treat 404 as "no identity exists" (return null as data, not error)
                if (result.error && result.error.status === 404) {
                    return { data: null };
                }

                if (result.error) {
                    return { error: result.error };
                }

                return { data: result.data };
            },
            providesTags: (result, error, { tenancyId }) => [
                { type: "CustomEmailDomain", id: tenancyId }
            ]
        }),

        createIdentity: builder.mutation({
            query: (body) => ({
                url: 'api/identity/create',
                method: 'POST',
                body: body
            }),
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response?.status,
            invalidatesTags: (result, error, arg) => [
                { type: "CustomEmailDomain", id: arg.tenancyId }
            ]
        }),

        checkVerification: builder.mutation({
            query: ({ tenancyId }) => ({
                url: `api/identity/verify?tenancyId=${tenancyId}`,
                method: 'GET'
            }),
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response?.status,
            invalidatesTags: (result, error, { tenancyId }) => [
                { type: "CustomEmailDomain", id: tenancyId }
            ]
        }),

        removeIdentity: builder.mutation({
            query: ({ tenancyId }) => ({
                url: `api/identity/remove?tenancyId=${tenancyId}`,
                method: 'DELETE'
            }),
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response?.status,
            invalidatesTags: (result, error, { tenancyId }) => [
                { type: "CustomEmailDomain", id: tenancyId }
            ]
        }),

        updateIdentity: builder.mutation({
            query: (body) => ({
                url: 'api/identity/update',
                method: 'PUT',
                body: body
            }),
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response?.status,
            invalidatesTags: (result, error, arg) => [
                { type: "CustomEmailDomain", id: arg.tenancyId }
            ]
        }),
    })
});

export const {
    useGetIdentityStatusQuery,
    useLazyGetIdentityStatusQuery,
    useCreateIdentityMutation,
    useCheckVerificationMutation,
    useRemoveIdentityMutation,
    useUpdateIdentityMutation
} = emailIdentityServiceApi;